<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <ms-page-title />

    <ms-invoice-aging-summary-cards
        [summary]="summary()"
        [currency]="currency()"
        [isLoading]="isSummaryLoading()"
        [selectedBucket]="selectedBucket()"
        (bucketSelected)="onBucketSelected($event)" />

    <ms-property-charge-list
        [currentPropertyChargeListViewLocation]="PropertyChargeListViewLocations.InvoiceDashboardPage"
        [scheduleOptions]="schedules()"
        (filterChanged)="onFilterChanged($event)" />
</div>
